// extracted by mini-css-extract-plugin
module.exports = {"StaffCard":"StaffCard-module--StaffCard--1YfFc","Title":"StaffCard-module--Title--Nx_1R","JobTitle":"StaffCard-module--JobTitle--NEcOb"};